import { Image } from '@cian/ui-kit/image';
import classNames from 'classnames';
import * as React from 'react';

import styles from './Gallery.css';
import { Carousel, IAutoScrollSettings, TMedia } from '../../../../../shared/components/Carousel';
import { IOfferHelperProps } from '../../types/offer-card';

interface IGalleryProps {
  media: TMedia[];
  thumbnails: IOfferHelperProps['thumbnails'];
  deoptimised?: boolean;
  bookedFromCian?: boolean;
  bookedFromDeveloper?: boolean;
  autoScroll: boolean;
  autoScrollSettings?: IAutoScrollSettings;
  onChangeSlide(): void;
  isNewbuilding?: boolean;
}

export function Gallery({
  media,
  thumbnails,
  deoptimised,
  bookedFromCian,
  bookedFromDeveloper,
  autoScroll,
  autoScrollSettings,
  onChangeSlide,
  isNewbuilding,
}: IGalleryProps) {
  const hasThumbnails = thumbnails && thumbnails.length > 0;
  const isNewbuildingWithoutThumbnails = isNewbuilding && !hasThumbnails;

  if (media.length === 0) {
    return (
      <div className={classNames(styles['cont'], styles['cont--empty'])}>
        <Image src="" />
      </div>
    );
  }

  return (
    <div
      data-name="Gallery"
      className={classNames(
        styles['cont'],
        hasThumbnails && styles['cont--with-thumbnails'],
        isNewbuildingWithoutThumbnails && styles['cont-newbuilding'],
      )}
    >
      <Carousel
        autoScroll={autoScroll}
        autoScrollSettings={autoScrollSettings}
        media={media}
        deoptimised={deoptimised}
        bookedFromCian={bookedFromCian}
        bookedFromDeveloper={bookedFromDeveloper}
        onSlideChange={onChangeSlide}
        isNewbuilding={isNewbuilding}
      />
    </div>
  );
}
